import { postMember } from "@api/members";
import { failAlert, successAlert } from "@common/alert";
import { changeNotiConfirmOption } from "@common/confirm";
import { closeConfirmModal } from "@redux/action/confirm";
import { useState } from "react";

export const useNotiSettingHandler = ({ userInfo }) => {
  const [isToggleActive, setIsToggleActive] = useState(false);
  // 사용자 push 알림 허용 유무 정보
  const getPushStats = () => {
    if (userInfo?.Member?.pushYn === "Y") {
      setIsToggleActive(true);
    } else setIsToggleActive(false);
  };

  // 사용자 알림 on/off 설정 action handler
  const onClickToggleBtnActionHandler = async () => {
    setIsToggleActive(!isToggleActive);

    const body = {
      modes: "PushSet",
      select: !isToggleActive === true ? "Y" : "N",
    };

    const res = await postMember(body);

    if (res.Code === "0000") {
      closeConfirmModal();
      return successAlert(res.Data.Msg);
    } else {
      closeConfirmModal();
      return failAlert(res.Data.MSg);
    }
  };
  // 사용자 알림 on/off 설정
  const onClickToggleBtn = () => {
    modifyConfirmModal({
      ...changeNotiConfirmOption,
      onAction: () => {
        onClickToggleBtnActionHandler();
      },
    });
    return openConfirmModal();
  };

  return { isToggleActive, getPushStats, onClickToggleBtn };
};
